import * as type from '../types';
import {
    getCookiesAcceptance,
    getDrawer,
    getTheme,
    setCookieAccepted,
    setDrawer,
    setTheme
} from '../../config/localStorage';
import { getRodo } from '../../config/sessionData';

const initialState = {
    isLoaded: true,
    isSnackbar: false,
    isDrawerOpen: getDrawer(),
    snackBarMessage: "",
    snackType: "info",
    themeType: getTheme(),
    welcomeDialog: false,
    cookiesAccepted: getCookiesAcceptance(),
    notifications: [],
    rodoNotAccepted: getRodo(),
    isForcedPasswordDialogOpen: false,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case type.REQUEST_LOADER:
            return {
                ...state,
                isLoaded: action.value
            };
        case type.OPEN_SNACKBAR:
            return {
                ...state,
                isSnackbar: true,
                snackBarMessage: action.value,
                snackType: action.snackType
            };
        case type.CLOSE_SNACKBAR:
            return {
                ...state,
                isSnackbar: false,
            };
        case type.CHANGE_THEME: {
            return {
                ...state,
                themeType: setTheme(state.themeType)
            };
        }
        case type.CHANGE_DRAWER: {
            setDrawer(!state.isDrawerOpen);
            return {
                ...state,
                isDrawerOpen: !state.isDrawerOpen
            };
        }
        case type.ClOSE_DRAWER:
            return {
                ...state,
                isDrawerOpen: false
            };
        case type.CLOSE_WELCOME_DIALOG:
            return {
                ...state,
                welcomeDialog: action.value
            };
        case type.SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.value
            };
        case type.SET_NOTIFICATION_READ:
            return {
                ...state,
                notifications: state.notifications.map(notification => {
                    if(notification.powiadomienia_id === action.value)
                        notification.nowe = false;
                    return notification;
                })
            };
        case type.SET_COOKIES_ACCEPTED:{
            setCookieAccepted();
            return {
                ...state,
                cookiesAccepted: action.value
            };
        }
        case type.SET_RODO_ACCEPTED: {
            return {
                ...state,
                rodoNotAccepted: action.value
            };
        }
        case type.SET_OPEN_CONFIRMED_FORCED_PASSWORD_DIALOG: {
            return {
                ...state,
                isForcedPasswordDialogOpen: action.value
            };
        }
        default: return state;
    }
}
